import { InjectionToken } from '@angular/core';

export const UI_DIALOG_DATA = new InjectionToken<any>('a3l-ui-dialog-data');
export const UI_DIALOG_CONFIG = new InjectionToken<any>('a3l-ui-dialog-config');
